<template>
  <div>
     <l-map ref="map" class="project-sidebar-map" :minZoom="minZoom" :options="mapOptions" :crs="crs">
       <l-circle v-for="(item, index) in items" v-bind:key="index" :radius="5" :fillOpacity="1" :stroke="false" :fillColor="'#334274'" :latLng="item.position"></l-circle>
       <l-area v-for="area in areas"
          :transformable="false"
          :textSmall="true"
          :fill-opacity="0"
          :lat-lng="area.latLng"
          :title="area.title"
          :size="area.size"
          :internal="area.internal"
          :circle="area.circle"
          :class-name="area['.key']"
          :opacity="1"
          v-bind:key="area['.key']"
        >
        </l-area>
      </l-map>
      <div class="project-sidebar-map-open" @click="openProjectMap()">
       <svgicon icon="fullscreen" width="48" height="48" color="#334274"></svgicon>
      </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import L from 'leaflet'
import { LMap, LCircle, LImageOverlay } from 'vue2-leaflet'
import LArea from '@/components/LArea' // eslint-disable-line
import 'leaflet/dist/leaflet.css'

var db = firebase.database()
var areasRef = db.ref('areas')

export default {
  name: 'ProjectSidebarMap',
  props: ['items'],
  components: {
    LMap,
    LImageOverlay,
    LCircle,
    LArea
  },
  data () {
    return {
      mapOptions: {
        zoomControl: false
        // zoomControl: false,
        // padding: [100,100]
      },
      crs: L.CRS.Simple,
      minZoom: -100
      // center: L.latLng(500, 500)
    }
  },
  methods: {
    bounds (latLng, size) {
      let bound0 = L.latLng(latLng.lat - size.height / 2, latLng.lng + size.width / 2)
      let bound1 = L.latLng(latLng.lat + size.height / 2, latLng.lng - size.width / 2)
      let bounds = [bound0, bound1]
      return bounds
    },
    imageUrl (number) {
      return require('@/assets/naturalCircle' + number + '.svg')
    },
    openProjectMap () {
      this.$router.push({name: 'Map', params: {project: this.$parent.$parent.project['.key']}})
    }
  },
  mounted () {
    let checkBounds = []
    this.items.forEach(post => {
      checkBounds.push([post.position.lat, post.position.lng])
    })
    this.areas.forEach(post => {
      checkBounds.push([post.latLng.lat - post.size.height / 2, post.latLng.lng + post.size.width / 2])
      checkBounds.push([post.latLng.lat + post.size.height / 2, post.latLng.lng - post.size.width / 2])
    })
    this.$refs.map.mapObject.fitBounds(checkBounds)
    // this.$refs.map.mapObject.setMaxBounds([0, 0], [2000, 2000])
  },
  firebase () {
    return {
      areas: areasRef
    }
  }
}
</script>

<style lang="scss">
  .project-sidebar-map .leaflet-marker-icon text {
    text-transform: uppercase;
    letter-spacing: 1px;
    opacity: 0.35;
  }
  .project-sidebar-map {
    position: absolute !important;
    bottom: 0 !important;
    height: 50vh !important;
    -webkit-user-select: none;  /* Chrome all / Safari all */
    -moz-user-select: none;     /* Firefox all */
    -ms-user-select: none;      /* IE 10+ */
    user-select: none;
    position: relative;
    z-index: 1;
    left: 0 !important;
    right: 0 !important;
  }

  .project-sidebar-map-open {
    position: absolute;
    bottom: 30px;
    overflow: hidden;
    left: 30px;
    z-index: 2;
    background: #fff;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.1);
    height: 48px;
    width: 48px;
    line-height: 44px;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectSidebarMap.vue